module.exports = {
  HEALTH_CATEGORIES: ['Standard', 'Standard Plus', 'Preferred', 'Preferred Plus'],
  RIDER_LABELS: {
    adb: 'Accidental Death Benefit',
    wop: 'Waiver of Premium',
    child: 'Child',
    child_wop: 'Child/Waiver of Premium Combined',
    opr: 'Overloan Protection Rider',
    ltc: 'LTC Rider',
    dir: 'Disability Income Rider',
    esvr: 'Enhanced Surrender Value Rider',
    colr: 'Cost of Living Rider',
    sp: 'Spouse Term',
    gi: 'Guaranteed Insurability',
    ir: 'Income Rider',
    nlr: 'No Lapse Rider',
    aplr: 'Automatic Premium Loan Rider',
    ipr: 'Index Participation Rider'
  },
  FEE_TYPES: {
    PremiumLoad: 'Premium Load',
    ExpenseCharge: 'Expense Charge'
  },

  ANNUITY_RIDER_LABELS: {
    gmib: 'Guaranteed Minimum Income Benefit',
    gmwb: 'Guaranteed Minimum Withdrawal Benefit',
    gmab: 'Guaranteed Minimum Accumulation Benefit',
    gmdb: 'Guaranteed Minimum Death Benefit',
    ltc: 'Long-Term Care',
    dib: 'Disability Income Benefit',
    terminal_illness: 'Terminal Illness',
    nursing_home: 'Nursing Home Confinement',
    unemployment_waiver: 'Unemployment Waiver'
  },

  GUARANTEED_UNIVERSAL_LIFE_PRODUCTS: [
    'To age 121 (No Lapse U/L)',
    'To age 121 (Pay to 65)',
    'To age 121 (Pay to 100)',
    'To age 121 (20 Pay)',
    'To age 121 (10 Pay)',
    'To age 121 (Single Pay)',
    'To age 65',
    'To age 70',
    'To age 75',
    'To age 80',
    'To age 85',
    'To age 90',
    'To age 95',
    'To age 100',
    'To age 105',
    'To age 110'
  ],

  IUL_FEATURES: [
    'Chronic Illness Covered (ADB Rider)',
    'Critical Illness Covered (ADB Rider)',
    'Included Nursing Home Confinement Rider',
    'Included ROP Rider',
    'Income Benefits',
    'Living Benefits',
    'Market Value Adjustment',
    'Online Application',
    'Terminal Illness Covered (ADB Rider)'
  ],

  TERM_LIFE_INSURANCE_PRODUCTS: [
    '1 Year Term',
    '5 Year Term',
    '10 Year Term',
    '15 Year Term',
    '20 Year Term',
    '25 Year Term',
    '30 Year Term',
    '35 Year Term',
    '40 Year Term'
  ],

  OTHER_PRODUCTS: ['Whole Life', 'Final Expense'],

  ROP_PRODUCTS: [
    '15 Year Term ROP',
    '20 Year Term ROP',
    '25 Year Term ROP',
    '30 Year Term ROP',
    'To age 65 (ROP)',
    'To age 70 (ROP)',
    'To age 75 (ROP)'
  ],

  Vive_Term_Life: [
    '1 Year Term',
    '5 Year Term',
    '10 Year Term',
    '15 Year Term',
    '16 Year Term',
    '17 Year Term',
    '18 Year Term',
    '19 Year Term',
    '20 Year Term',
    '21 Year Term',
    '22 Year Term',
    '23 Year Term',
    '24 Year Term',
    '25 Year Term',
    '26 Year Term',
    '27 Year Term',
    '28 Year Term',
    '29 Year Term',
    '30 Year Term',
    '35 Year Term',
    '40 Year Term'
  ],
  Vive_Return_of_Premium: [
    '15 Year Term ROP',
    '20 Year Term ROP',
    '25 Year Term ROP',
    '30 Year Term ROP'
  ],

  PRODUCT_TYPE_DETAILS_BY_PRODUCT_TYPE: {
    'Fixed Annuity': ['Fixed Annuity', 'Fixed Indexed Annuity', 'MYGA'],
    Term: [
      '1 Year Term',
      '5 Year Term',
      '10 Year Term',
      '11 Year Term',
      '12 Year Term',
      '13 Year Term',
      '14 Year Term',
      '15 Year Term',
      '16 Year Term',
      '17 Year Term',
      '18 Year Term',
      '19 Year Term',
      '20 Year Term',
      '21 Year Term',
      '22 Year Term',
      '23 Year Term',
      '24 Year Term',
      '25 Year Term',
      '26 Year Term',
      '27 Year Term',
      '28 Year Term',
      '29 Year Term',
      '30 Year Term',
      '31 Year Term',
      '32 Year Term',
      '33 Year Term',
      '34 Year Term',
      '35 Year Term',
      '40 Year Term'
    ],
    'Term ROP': [
      '1 Year Term ROP',
      '5 Year Term ROP',
      '10 Year Term ROP',
      '12 Year Term ROP',
      '15 Year Term ROP',
      '16 Year Term ROP',
      '17 Year Term ROP',
      '18 Year Term ROP',
      '19 Year Term ROP',
      '20 Year Term ROP',
      '21 Year Term ROP',
      '22 Year Term ROP',
      '23 Year Term ROP',
      '24 Year Term ROP',
      '25 Year Term ROP',
      '26 Year Term ROP',
      '27 Year Term ROP',
      '28 Year Term ROP',
      '29 Year Term ROP',
      '30 Year Term ROP',
      '31 Year Term ROP',
      '32 Year Term ROP',
      '33 Year Term ROP',
      '34 Year Term ROP',
      '35 Year Term ROP',
      '40 Year Term ROP'
    ],
    UL: [
      'To age 65',
      'To age 65 (ROP)',
      'To age 70',
      'To age 70 (ROP)',
      'To age 75',
      'To age 75 (ROP)',
      'To age 80',
      'To age 85',
      'To age 90',
      'To age 95',
      'To age 100',
      'To age 105',
      'To age 110',
      'To age 115',
      'To age 121 (No Lapse U/L)',
      'To age 121 (Pay to 65)',
      'To age 121 (Pay to 100)',
      'To age 121 (20 Pay)',
      'To age 121 (10 Pay)',
      'To age 121 (Single Pay)'
    ],
    IUL: [
      'To age 65 (IUL)',
      'To age 70 (IUL)',
      'To age 75 (IUL)',
      'To age 80 (IUL)',
      'To age 85 (IUL)',
      'To age 90 (IUL)',
      'To age 95 (IUL)',
      'To age 100 (IUL)',
      'To age 105 (IUL)',
      'To age 110 (IUL)',
      'To age 115 (IUL)',
      'To age 121 (IUL)'
    ],
    VUL: [
      'To age 65 (VUL)',
      'To age 70 (VUL)',
      'To age 75 (VUL)',
      'To age 80 (VUL)',
      'To age 85 (VUL)',
      'To age 90 (VUL)',
      'To age 95 (VUL)',
      'To age 100 (VUL)',
      'To age 105 (VUL)',
      'To age 110 (VUL)',
      'To age 115 (VUL)',
      'To age 121 (VUL)'
    ],
    'Long Term Care': ['Long Term Care'],
    'Final Expense': ['Final Expense'],
    'Whole Life': ['Whole Life']
  },

  STATES: [
    {
      label: 'Alabama',
      value: 'AL'
    },
    {
      label: 'Alaska',
      value: 'AK'
    },
    {
      label: 'American Samoa',
      value: 'AS'
    },
    {
      label: 'Arizona',
      value: 'AZ'
    },
    {
      label: 'Arkansas',
      value: 'AR'
    },
    {
      label: 'California',
      value: 'CA'
    },
    {
      label: 'Colorado',
      value: 'CO'
    },
    {
      label: 'Connecticut',
      value: 'CT'
    },
    {
      label: 'Delaware',
      value: 'DE'
    },
    {
      label: 'District of Columbia',
      value: 'DC'
    },
    {
      label: 'Federated States of Micronesia',
      value: 'FM'
    },
    {
      label: 'Florida',
      value: 'FL'
    },
    {
      label: 'Georgia',
      value: 'GA'
    },
    {
      label: 'Guam',
      value: 'GU'
    },
    {
      label: 'Hawaii',
      value: 'HI'
    },
    {
      label: 'Idaho',
      value: 'ID'
    },
    {
      label: 'Illinois',
      value: 'IL'
    },
    {
      label: 'Indiana',
      value: 'IN'
    },
    {
      label: 'Iowa',
      value: 'IA'
    },
    {
      label: 'Kansas',
      value: 'KS'
    },
    {
      label: 'Kentucky',
      value: 'KY'
    },
    {
      label: 'Louisiana',
      value: 'LA'
    },
    {
      label: 'Maine',
      value: 'ME'
    },
    {
      label: 'Marshal Islands',
      value: 'MH'
    },
    {
      label: 'Maryland',
      value: 'MD'
    },
    {
      label: 'Massachusetts',
      value: 'MA'
    },
    {
      label: 'Michigan',
      value: 'MI'
    },
    {
      label: 'Minnesota',
      value: 'MN'
    },
    {
      label: 'Mississippi',
      value: 'MS'
    },
    {
      label: 'Missouri',
      value: 'MO'
    },
    {
      label: 'Montana',
      value: 'MT'
    },
    {
      label: 'Nebraska',
      value: 'NE'
    },
    {
      label: 'Nevada',
      value: 'NV'
    },
    {
      label: 'New Hampshire',
      value: 'NH'
    },
    {
      label: 'New Jersey',
      value: 'NJ'
    },
    {
      label: 'New Mexico',
      value: 'NM'
    },
    {
      label: 'New York',
      value: 'NY'
    },
    {
      label: 'North Carolina',
      value: 'NC'
    },
    {
      label: 'North Dakota',
      value: 'ND'
    },
    {
      label: 'Northern Mariana Islands',
      value: 'MP'
    },
    {
      label: 'Ohio',
      value: 'OH'
    },
    {
      label: 'Oklahoma',
      value: 'OK'
    },
    {
      label: 'Oregon',
      value: 'OR'
    },
    {
      label: 'Palau',
      value: 'PW'
    },
    {
      label: 'Pennsylvania',
      value: 'PA'
    },
    {
      label: 'Puerto Rico',
      value: 'PR'
    },
    {
      label: 'Rhode Island',
      value: 'RI'
    },
    {
      label: 'South Carolina',
      value: 'SC'
    },
    {
      label: 'South Dakota',
      value: 'SD'
    },
    {
      label: 'Tennessee',
      value: 'TN'
    },
    {
      label: 'Texas',
      value: 'TX'
    },
    {
      label: 'Utah',
      value: 'UT'
    },
    {
      label: 'Vermont',
      value: 'VT'
    },
    {
      label: 'Virgin Islands',
      value: 'VI'
    },
    {
      label: 'Virginia',
      value: 'VA'
    },
    {
      label: 'Washington',
      value: 'WA'
    },
    {
      label: 'West Virginia',
      value: 'WV'
    },
    {
      label: 'Wisconsin',
      value: 'WI'
    },
    {
      label: 'Wyoming',
      value: 'WY'
    }
  ],

  QUOTE_ACTIONS: [
    {
      value: 'default',
      label: 'Webhook GET',
      group: 'Basic',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp', 'AnnuityQuoter']
    },
    {
      value: 'ethos',
      label: 'Ethos',
      group: 'Instant Issue',
      products: []
    },
    {
      value: 'webhook_post',
      label: 'Webhook POST',
      group: 'Basic',
      products: ['BgaQuoter', 'AnnuityQuoter']
    },
    {
      value: 'simple_url',
      label: 'Simple URL (No Data Payload)',
      group: 'Basic',
      products: ['BgaQuoter', 'AnnuityQuoter']
    },
    {
      value: 'applicant',
      label: 'ApplicInt',
      group: 'E-Ticket',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'protective',
      label: 'Protective',
      group: 'E-Ticket',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'paclife',
      label: 'Pacific Life',
      group: 'E-Ticket',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'sbli',
      label: 'SBLI',
      group: 'E-Ticket',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'anico',
      label: 'American National',
      group: 'E-Ticket',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'firelight',
      label: 'Firelight',
      group: 'Integration',
      products: ['BgaQuoter', 'AnnuityQuoter', 'MobileApp']
    },
    {
      value: 'psg_eapp',
      label: 'PSG E-Application',
      group: 'E-App',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'typeform',
      label: 'TypeForm',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'formassembly',
      label: 'FormAssembly',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: '123_contact_form',
      label: '123 Contact Form',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'cognito_form',
      label: 'Cognito Form',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'formsite',
      label: 'Formsite',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'jotform',
      label: 'Jotform',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'formstack',
      label: 'FormStack',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'wufoo',
      label: 'Wufoo',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'google_form',
      label: 'Google Form',
      group: 'Form',
      products: ['WebsiteQuoter', 'BgaQuoter', 'MobileApp']
    },
    {
      value: 'send_quote_as_email',
      label: 'Email PDF',
      group: 'Default',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'send_quote_as_text',
      label: 'Text PDF',
      group: 'Default',
      products: ['BgaQuoter', 'MobileApp']
    },
    {
      value: 'download_quotes_pdf',
      label: 'Download PDF',
      group: 'Default',
      products: ['BgaQuoter']
    },
    {
      value: 'request_forms',
      label: 'Request Forms',
      group: 'Default',
      products: ['BgaQuoter']
    },
    {
      value: 'standard_packet',
      label: 'Standard Packet',
      group: 'Default',
      products: ['BgaQuoter']
    },
    {
      value: 'nmb_term_eticket',
      label: 'National Mutual Benefit Term E-Ticket',
      group: 'E-Ticket',
      products: ['BgaQuoter']
    },
    {
      value: 'nmb_whole_life_eticket',
      label: 'National Mutual Benefit Whole Life E-Ticket',
      group: 'E-Ticket',
      products: ['BgaQuoter']
    },
    {
      value: 'simplified_eticket',
      label: 'Simplified E-Ticket',
      group: 'E-Ticket',
      products: ['BgaQuoter']
    }
  ],

  FIRELIGHT_ACTIVITIES: [
    { label: 'e-Application', value: 'e_app' },
    { label: 'e-Ticket', value: 'e_ticket' },
    { label: 'simplified-eticket', value: 'simplified_eticket' }
  ],

  WEBSITE_QUOTER_ACTIONS: [
    { value: 'ixn_lead_form', label: 'IXN Lead Form', group: 'Default' },
    { value: 'typeform', label: 'TypeForm', group: '3rd Party Forms' },
    { value: 'formassembly', label: 'FormAssembly', group: '3rd Party Forms' },
    { value: '123_contact_form', label: '123 Contact Form', group: '3rd Party Forms' },
    { value: 'cognito_form', label: 'Cognito Form', group: '3rd Party Forms' },
    { value: 'formsite', label: 'Formsite', group: '3rd Party Forms' },
    { value: 'jotform', label: 'Jotform', group: '3rd Party Forms' },
    { value: 'formstack', label: 'FormStack', group: '3rd Party Forms' },
    { value: 'wufoo', label: 'Wufoo', group: '3rd Party Forms' },
    { value: 'google_form', label: 'Google Form', group: '3rd Party Forms' },
    { value: 'get', label: 'Webhook GET', group: 'Webhooks' }
  ],

  PASSWORD_RULES: [
    { name: 'numbers', pattern: /(.*[0-9]){2}/, label: 'At least 2 numbers' },
    { name: 'uppercase', pattern: /[A-Z]/, label: 'At least 1 uppercase letter' },
    { name: 'lowercase', pattern: /[a-z]/, label: 'At least 1 lowercase letter' },
    {
      name: 'special_char',
      pattern: /[!#$%&()*+,-.\/:;<=>?@[\]^_`{|}~]/,
      label: 'At least 1 special character'
    },
    { name: 'length', pattern: /.{8,}/, label: 'At least 8 total characters' }
  ],

  NOTIFICATION_TRIGGERS: [
    { label: 'E-Ticket - Started', value: 'eticket_created' },
    { label: 'E-Ticket - Error', value: 'eticket_error' },
    { label: 'E-Ticket - Completed', value: 'eticket_sent' },
    { label: 'E-Application - Started', value: 'e_app_started' },
    { label: 'E-Application - Error', value: 'e_app_error' },
    { label: 'E-Application - Locked', value: 'e_app_locked' },
    { label: 'E-Application - Signing', value: 'e_app_signing' },
    { label: 'E-Application - Completed', value: 'e_app_completed' },
    { label: 'Lead Created', value: 'lead_created' },
    { label: 'Lead Updated', value: 'lead_updated' },
    { label: 'Member Created', value: 'member_created' },
    { label: 'Underwriting Pre-screener Submitted', value: 'uwp_created' },
    { label: 'Carrier Forms Request', value: 'forms_requested' }
  ],

  TABLE_RATE_LETTERS: [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V'
  ],

  FORMULA_LABELS: {
    base_premium: 'Base Premium',
    policy_fee: 'Policy Fee',
    table_rate_fee: 'Table Rate Fee',
    adb_rider_fee: 'ADB Rider Fee',
    wop_rider_fee: 'WOP Rider Fee',
    child_rider_fee: 'Child Rider Fee',
    child_wop_rider_fee: 'Combined Child/WOP Rider Fee',
    flat_extra_fee: 'Flat Extra Fee',
    total: 'Total'
  },

  DEFAULT_FORMULAS: {
    base_premium: 'round((AGE_RATE * FACE_AMOUNT_IN_THOUSANDS * MODAL_FACTOR), 2)',
    policy_fee: 'round((POLICY_FEE * MODAL_FACTOR), 2)',
    table_rate_fee: 'round((BASE_PREMIUM * TABLE_RATE_PERCENT), 2)',
    adb_rider_fee: 'round(((MAX_BENEFIT_COVERAGE / 1000) * RIDER_RATE) * MODAL_FACTOR, 2)',
    wop_rider_fee: 'round((RIDER_RATE * FACE_AMOUNT_IN_THOUSANDS * MODAL_FACTOR), 2)',
    child_rider_fee: 'round((RIDER_RATE * CHILD_RIDER_UNITS * MODAL_FACTOR), 2)',
    child_wop_rider_fee: 'round((RIDER_RATE * CHILD_RIDER_UNITS * MODAL_FACTOR), 2)',
    flat_extra_fee: 'round((FLAT_EXTRA_TOTAL * MODAL_FACTOR), 2)',
    total:
      'round((BASE_PREMIUM + POLICY_FEE + TABLE_RATE_FEE + FLAT_EXTRA_FEE + ADB_RIDER_FEE + WOP_RIDER_FEE + CHILD_RIDER_FEE + CHILD_WOP_RIDER_FEE), 2)'
  },

  FORMULA_VARIABLES: {
    base_premium: ['AGE_RATE', 'FACE_AMOUNT_IN_THOUSANDS', 'MODAL_FACTOR'],
    policy_fee: ['MODAL_FACTOR', 'POLICY_FEE'],
    table_rate_fee: [
      'AGE_RATE',
      'BASE_PREMIUM',
      'FACE_AMOUNT_IN_THOUSANDS',
      'MODAL_FACTOR',
      'TABLE_RATE_PERCENT'
    ],
    adb_rider_fee: ['MAX_BENEFIT_COVERAGE', 'MODAL_FACTOR', 'RIDER_RATE'],
    wop_rider_fee: [
      'ADB_RIDER_FEE',
      'BASE_PREMIUM',
      'CHILD_RIDER_FEE',
      'FACE_AMOUNT_IN_THOUSANDS',
      'FLAT_EXTRA_FEE',
      'MODAL_FACTOR',
      'POLICY_FEE',
      'RIDER_RATE',
      'TABLE_RATE_FEE'
    ],
    child_rider_fee: ['CHILD_RIDER_UNITS', 'COVERAGE_PER_UNIT', 'MODAL_FACTOR', 'RIDER_RATE'],
    child_wop_rider_fee: ['CHILD_RIDER_UNITS', 'MODAL_FACTOR', 'RIDER_RATE', 'TABLE_RATE_PERCENT'],
    flat_extra_fee: ['FLAT_EXTRA_TOTAL', 'MODAL_FACTOR'],
    total: [
      'ADB_RIDER_FEE',
      'BASE_PREMIUM',
      'CHILD_RIDER_FEE',
      'CHILD_WOP_RIDER_FEE',
      'FLAT_EXTRA_FEE',
      'MODAL_FACTOR',
      'POLICY_FEE',
      'TABLE_RATE_FEE',
      'WOP_RIDER_FEE'
    ]
  },

  PAYMENT_MODES: {
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    semi_annual: 'Semi-Annual',
    annual: 'Annual'
  }
};
